import initialState from "../../../store/initialState";
import * as types from "../services/TimeZoneMasterActionType";

const timeZoneMasterReducer = (
  state = initialState.timeZoneMasterReducer,
  action,
) => {
  switch (action.type) {
    case types.MASTER_TIMEZONE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case types.MASTER_TIMEZONE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        masterTimeZone: action.payload,
        error: null,
      };
    case types.MASTER_TIMEZONE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default timeZoneMasterReducer;